import { Table } from '@nimbus-ds/components';
import { CustomHeaderCell } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

export function MetaplansListHeader() {
  const t = useTranslationCatalog();

  return (
    <Table.Head>
      <Table.Row>
        <CustomHeaderCell width={{ xl: 'auto' }}>
          {t('subscriptions.table.headers.planName')}
        </CustomHeaderCell>
        <CustomHeaderCell width={{ xl: '500px', lg: '400px' }}>
          {t('subscriptions.table.headers.condition')}
        </CustomHeaderCell>
        <CustomHeaderCell width={{ md: '80px' }}>
          {t('subscriptions.table.headers.actions')}
        </CustomHeaderCell>
      </Table.Row>
    </Table.Head>
  );
}
